import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useMap } from "react-leaflet";
import { LocateFixed } from "lucide-react";
import L from "leaflet";
import { MapFullscreenControl } from "./MapFullscreenControl";

export const MapCenterControl = ({ pins, testId }) => {
  const map = useMap();
  const [container, setContainer] = useState(null);
  const label = pins.length > 1 ? "Center to Pins" : "Center to Pin";

  useEffect(() => {
    const control = L.control({ position: "topleft" });
    control.onAdd = () => {
      const node = L.DomUtil.create("div", "leaflet-bar leaflet-control-center");
      L.DomEvent.disableClickPropagation(node);
      L.DomEvent.disableScrollPropagation(node);
      setContainer(node);
      return node;
    };
    control.addTo(map);
    for (const direction of ["in", "out"]) {
      const button = map.getContainer().querySelector(`.leaflet-control-zoom-${direction}`);
      if (button) button.dataset.testid = `${testId}-zoom-${direction}`;
    }
    return () => control.remove();
  }, [map, testId]);

  const center = () => {
    if (!pins.length) return;
    map.stop();
    map.invalidateSize({ pan: false });
    if (pins.length === 1) map.setView([pins[0].lat, pins[0].lng], map.getZoom(), { animate: false });
    else map.fitBounds(L.latLngBounds(pins.map(({ lat, lng }) => [lat, lng])).pad(0.3), { maxZoom: 16, animate: false });
  };

  return <><MapFullscreenControl testId={testId} />{container && createPortal(
    <button type="button" data-testid={`${testId}-center`} disabled={!pins.length}
      aria-label={pins.length ? label : "Center to Pin — no pins available"}
      title={pins.length ? label : "No pins available"} onClick={center}>
      <LocateFixed size={16} aria-hidden="true" />
    </button>, container)}</>;
};
